// apps/web/src/components/coletor/usb-reader.ts — Fase 02, Plano 07 (APT-02, Assumption A3).
//
// Listener de leitor de código de barras / QR USB (emulação de teclado HID).
// Detecta rajadas de teclas (intervalo entre keydowns < 50ms) terminadas com a tecla Enter.
// Funciona em paralelo à câmera do tablet sem necessidade de alternar modo.

export interface UsbReaderOptions {
  readonly maxIntervalMs?: number;
  readonly minLength?: number;
  readonly onScan: (scannedText: string) => void;
}

export function attachUsbReader(options: UsbReaderOptions): () => void {
  const maxInterval = options.maxIntervalMs ?? 50;
  const minLength = options.minLength ?? 3;

  let buffer = '';
  let lastKeyTime = 0;

  const handleKeyDown = (event: KeyboardEvent) => {
    const now = Date.now();
    const target = event.target as HTMLElement | null;

    // Ignora digitação em campos de texto padrão (input, textarea), exceto se for burst rápido do scanner
    const isEditing = target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA');

    if (event.key === 'Enter') {
      if (buffer.length >= minLength) {
        // Se a rajada foi rápida, consome o evento e emite o scan
        const timeDiff = now - lastKeyTime;
        if (timeDiff <= maxInterval || buffer.length > 5) {
          event.preventDefault();
          const scanned = buffer.trim();
          buffer = '';
          options.onScan(scanned);
          return;
        }
      }
      buffer = '';
      return;
    }

    if (event.key.length === 1) {
      if (lastKeyTime > 0 && now - lastKeyTime > maxInterval && !isEditing) {
        // Intervalo muito longo entre teclas -> digitação manual lenta, reseta buffer se fora de input
        buffer = '';
      }

      buffer += event.key;
      lastKeyTime = now;
    }
  };

  window.addEventListener('keydown', handleKeyDown, true);

  return () => {
    window.removeEventListener('keydown', handleKeyDown, true);
  };
}
